function addClassNameListener() {
    window.setInterval( function() {   
        if ($('#count-down-timer').length > 0  && !$('#count-down-timer').hasClass('active')) {
            $('#count-down-timer').addClass('active');
            startTimer(60 * 15, document.getElementById('count-down-timer')); 
        }
    },100);
}

function startTimer(duration, display) {
    if (display) {
        let timer = duration, minutes, seconds;
          setInterval(function () {
              minutes = parseInt(timer / 60, 10)
              seconds = parseInt(timer % 60, 10);
              minutes = minutes < 10 ? "0" + minutes : minutes;
              seconds = seconds < 10 ? "0" + seconds : seconds;
              display.textContent = minutes + ":" + seconds;
              if (--timer < 0) {
                  timer = 0;
              }
          }, 1000);
    } else {
      setTimeout(function(){
        addClassNameListener();
      },1500);
    }
}

window.addEventListener("load", (event) => {
  addClassNameListener();
});


// $(document).on('click','.product-form__submit, .quantity__button', function(){
//    addClassNameListener();
// });